import React from 'react';

const ErrorView: React.FC = () => {
  return (
    <div className="size-full flex flex-col items-center">
      <p className="text-base leading-5 text-center text-neutral-800 text-opacity-70 mb-6">
        Something went wrong. Please try again.
      </p>
    </div>
  );
};

export default ErrorView;
